module.exports = __webpack_public_path__ + "media/images/countrysquared/ki-519834878703dd28a01abae8d575dddc.svg";